import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    if (!url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }

    let normalizedUrl = url.trim();

    if (normalizedUrl.includes('youtube.com') || normalizedUrl.includes('youtu.be')) {
      normalizedUrl = this.normalizeYouTubeUrl(normalizedUrl);
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(normalizedUrl);
  }

  private normalizeYouTubeUrl(url: string): string {
    let videoId = '';
    
    try {
      if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1].split('?')[0].split('&')[0].split('/')[0];
      } else if (url.includes('youtube.com/watch?v=')) {
        videoId = url.split('watch?v=')[1].split('&')[0].split('#')[0];
      } else if (url.includes('youtube.com/embed/')) {
        videoId = url.split('embed/')[1].split('?')[0].split('&')[0].split('/')[0];
      } else if (url.includes('youtube.com/v/')) {
        videoId = url.split('v/')[1].split('?')[0].split('&')[0].split('#')[0];
      }

      if (videoId) {
        videoId = videoId.trim().replace(/[^a-zA-Z0-9_-]/g, '');
        if (videoId.length >= 10 && videoId.length <= 11) {
          return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&enablejsapi=1`;
        }
      }
    } catch (e) {
      console.error('YouTube URL normalization error:', e);
    }

    return url;
  }
}
